import { render, staticRenderFns } from "./newpage.vue?vue&type=template&id=69c9fa32&scoped=true&"
import script from "./newpage.vue?vue&type=script&lang=js&"
export * from "./newpage.vue?vue&type=script&lang=js&"
import style0 from "./newpage.vue?vue&type=style&index=0&id=69c9fa32&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69c9fa32",
  null
  
)

export default component.exports